import { gql } from '@apollo/client';

export const PROPERTY_PROJECT_LOGOS_FRAGMENT = gql`
  fragment PropertyProjectLogos on Property {
    projectLogos {
      list {
        id
        url
        link
        order
        width
        height
      }
    }
  }
`;
